import React from "react";

// PNG thumbnail input with local preview. The parent owns the selected File and
// the object-URL preview (both are part of the add-flow submit gate).
const ThumbnailField = ({ previewUrl, currentUrl, onSelect }) => {
    return (
        <div className="olp-field">
            <label htmlFor="ThumbnailUrl">Thumbnail dosyasını seçiniz: </label>
            {currentUrl && !previewUrl && <img className="olp-thumb-preview" src={currentUrl} alt="thumbnail" />}
            <input
                accept="image/png"
                type="file"
                name="ThumbnailUrl"
                id="ThumbnailUrl"
                onChange={(e) => {
                    const selectedFile = e.target.files[0];
                    if (!selectedFile) return;
                    onSelect(selectedFile, URL.createObjectURL(selectedFile));
                }}
            />
            {previewUrl && <img className="olp-thumb-preview" src={previewUrl} alt="thumbnail önizleme" />}
        </div>
    );
};

export default ThumbnailField;
